var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.ready)?_c('div',{staticClass:"h-100"},[_c('transition',{attrs:{"name":"intro","appear":""}},[_c('Window')],1)],1):_c('div',{class:`h-100 bg-${_vm.themeVariant}`,staticStyle:{"overflow-y":"auto"}},[_c('Onboarding',{attrs:{"relay-auth-to-electron":_vm.isAuthMode}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }